import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  getCategories,
  removeArticle,
  newUserArticle,
} from "../../actions/freelancer";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  Button,
  UncontrolledAlert,
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";

import DropdownSelection from "../../components/Commons/DropdownSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/userarticles/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";
import { Link } from "react-router-dom";
import NewModal from "../../components/profile/NewModal";

const CATEGORIES = [
  {
    id: 102,
    parent_id: 101,
    sort: 1,
    name: "spring_festival_party",
    display_name: "春節遊園會",
  },
  {
    id: 103,
    parent_id: 101,
    sort: 2,
    name: "McDonald's_events",
    display_name: "麥當勞教育展",
  },
  {
    id: 106,
    parent_id: 105,
    sort: 1,
    name: "sales_info",
    display_name: "促銷活動",
  },
  {
    id: 107,
    parent_id: 105,
    sort: 2,
    name: "merchants_info",
    display_name: "商家信息",
  },
  {
    id: 109,
    parent_id: 108,
    sort: 1,
    name: "foodies",
    display_name: "美食",
  },
  {
    id: 110,
    parent_id: 108,
    sort: 2,
    name: "real_estate",
    display_name: "房地產",
  },
  {
    id: 111,
    parent_id: 108,
    sort: 3,
    name: "health",
    display_name: "健康養生",
  },
  {
    id: 112,
    parent_id: 108,
    sort: 4,
    name: "entertainment_channel",
    display_name: "娛樂",
  },
  {
    id: 113,
    parent_id: 108,
    sort: 5,
    name: "traveling",
    display_name: "旅遊",
  },
  {
    id: 159,
    parent_id: 108,
    sort: 6,
    name: "traveling",
    display_name: "體育",
  },
];
class FreelancerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      articles: [],
      article: {
        category_ids: [],
      },
      operationNewModal: false,
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.toggleNewModal = this.toggleNewModal.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType,
    });
    this.getCategories();
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getCurrentCategory(category_id) {
    var matchRoles = CATEGORIES.filter((value) => {
      return value.id == category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCategories() {
    this.props.getCategories();
  }

  hideAlert() {
    this.setState({
      alert: "",
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: "",
    });
    let path = "user";
    let post_id = row.post.id;
    this.props.removeArticle({ post_id, path });
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      ),
    });
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params,
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  filterAuthor(author_id) {
    // const activeCategoryType = this.getCurrentCategory(author_id);
    // this.setState({
    //   activeCategoryType: activeCategoryType
    // });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      author_id,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1,
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  toggleNewModal = (state) => {
    this.setState({
      operationNewModal: !this.state.operationNewModal,
    });
  };

  handleCheckBoxChange(e) {
    const { checked, value } = e.target;
    let article = this.state.article;
    if (checked && article.category_ids.indexOf(value) === -1) {
      article.category_ids.push(parseInt(value));
    } else {
      article.category_ids = article.category_ids.filter(
        (id) => id !== parseInt(value)
      );
    }
    this.setState({
      article: article,
    });
  }

  submitArticle() {
    let { article } = this.state;
    const category_ids = article.category_ids;
    this.props.newUserArticle({
      category_ids,
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      errorMsg,
      successBackMsg,
      getArticleRequest,
      editArticleRequest,
    } = this.props.freelancer;
    var activeCategoryType = this.state.activeCategoryType;

    const heads = ["狀態", "標題", "分類", "發布日期", "操作"];
    const dataAttributes = [
      "status",
      "title",
      "category",
      "author",
      "created_at",
    ];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between"></div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <DropdownSelection
                  Types={CATEGORIES}
                  activeType={activeCategoryType}
                  filterType={this.filterCat}
                />
              </div>
              <div className="d-flex align-items-center">
                <Button
                  className="btn btn-default"
                  onClick={this.toggleNewModal}
                >
                  寫文章
                </Button>
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={(page) => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
        <NewModal
          data={this.state.article}
          handleCheckBoxChange={this.handleCheckBoxChange}
          submitArticle={this.submitArticle}
          loading={editArticleRequest}
          toggleNewModal={this.toggleNewModal}
          operationNewModal={this.state.operationNewModal}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    freelancer: state.freelancer,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getArticles: (params) => dispatch(getArticles(params)),
    getCategories: (params) => dispatch(getCategories(params)),
    removeArticle: (params) => dispatch(removeArticle(params)),
    newUserArticle: (params) => dispatch(newUserArticle(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreelancerPage);
